<nb-card>
  <nb-card-body>
    <div class="col" style="text-align: center;">
      <div *ngIf="loading">
        <div><p-progressSpinner></p-progressSpinner></div>
        <p>Enviando uma nova senha...</p>
      </div>
      <div *ngIf="!loading && !confirmRecover" class="wrapper">
          <h4 *ngIf="!sucess">Erro ao recuperar senha</h4>
          <h4 *ngIf="sucess">Senha enviada com sucesso</h4>
          <p class="detail">
            Detalhes: {{ message }}
          </p>
      </div>
      <div *ngIf="confirmRecover">
        <h5>
          Redefinição de senha
        </h5>
        <p>
          Você receberá a nova senha no seu e-mail, <br> deseja continuar?
        </p>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer class="d-flex" style="justify-content: center;" *ngIf="!confirmRecover">
    <button type="button" class="btn btn-success" (click)="confirm()" [disabled]="loading">
      Confirmar
    </button>
  </nb-card-footer>
  <nb-card-footer class="d-flex" style="justify-content: space-around;" *ngIf="confirmRecover">
    <button type="button" class="btn btn-success px-4" (click)="recoverPassword()">
      Sim
    </button>
    <button type="button" class="btn btn-danger px-4" (click)="confirm()">
      Não
    </button>
  </nb-card-footer>
</nb-card>